var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.myRootComponent)?_c('ComponentWithPropertiesInstance',{key:_vm.myRootComponent.key,attrs:{"component":_vm.myRootComponent}}):_c('LoadingView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }